<template>
  <div class="page-wrapper py-4">
    <div id="master" ref="master" class="master" @scroll="handleScroll">
      <menutop :menu/>
      <RewardHeroNew id="page1" bg="white" class="section" />
      <LealtadRewardNew id="page2" bg="black" class="section" />
      <GiftCardRewardNew id="page3" bg="black" class="section" />
      <SistemaMarcaRewardNew id="page4" bg="white" class="section" />
      <TituloLealtadNew id="page5" bg="black" class="section" />
      <ProgramaLealtadRewardNew id="page6" bg="white" class="section" />
      <GiftCardsDigitalesNew id="page7" bg="white" class="section" />
      <TestimonioRewardNew id="page8" bg="white" class="section" />
      <CallToActionRewardNew id="page9" bg="white" class="section" />
      <FooterRewardNew id="page10" bg="black" class="section" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import menutop from '@/components/structure/menutop.vue'
import RewardHeroNew from '@/components/pages/reward/RewardHeroNew.vue'
import LealtadRewardNew from '@/components/pages/reward/LealtadRewardNew.vue'
import GiftCardRewardNew from '@/components/pages/reward/GiftCardRewardNew.vue'
import SistemaMarcaRewardNew from '@/components/pages/reward/SistemaMarcaRewardNew.vue'
import TituloLealtadNew from '@/components/pages/reward/TituloLealtadNew.vue'
import ProgramaLealtadRewardNew from '@/components/pages/reward/ProgramaLealtadRewardNew.vue'
import GiftCardsDigitalesNew from '@/components/pages/reward/GiftCardsDigitalesNew.vue'
import TestimonioRewardNew from '@/components/pages/reward/TestimonioRewardNew.vue'
import CallToActionRewardNew from '@/components/pages/reward/CallToActionRewardNew.vue'
import FooterRewardNew from '@/components/pages/reward/FooterRewardNew.vue'

export default {
  name: 'rewardView',
  props:{
      con: {
          default: {},
          type: Object
      }
  },
  components: {
    menutop,
    RewardHeroNew,
    LealtadRewardNew,
    GiftCardRewardNew,
    SistemaMarcaRewardNew,
    TituloLealtadNew,
    ProgramaLealtadRewardNew,
    GiftCardsDigitalesNew,
    TestimonioRewardNew,
    CallToActionRewardNew,
    FooterRewardNew
  },
  watch: {
    currentSection() {
      if(document.getElementById(`page${this.currentSection}`)) {
        console.log(document.getElementById(`page${this.currentSection}`).getAttribute('bg'), this.currentSection);
        this.menu = document.getElementById(`page${this.currentSection}`).getAttribute('bg');
      }
    }
  },
  data() {
    return {
      menu: 'white',
      currentSection: 1,
    };
  },
  methods: {
    handleScroll() {
      const scrollPosition = this.$refs.master.scrollTop;
      const windowHeight = window.innerHeight;
      const menuHeight = 80; // Altura del menutop
      const adjustedScrollPosition = scrollPosition + menuHeight;
      const section = Math.floor(adjustedScrollPosition  / windowHeight) + 1;
      if (section < 1) {
        this.currentSection = 1;
      } else if (section > 10) {
        this.currentSection = 10;
      } else {
        this.currentSection = section;
      }
    },

  },
}
</script>

<style lang="css">
/* 1) El wrapper ocupa toda la pantalla */
.page-wrapper {
  background-color: #F0EFEB; /* background color */
  width: 100%;
  height: 96vh;
  display: flex;
  justify-content: center; /* centra .master horizontalmente */
  align-items: center;     /* centra .master verticalmente */
  box-sizing: border-box;
}

.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);

  /* Firefox */
  scrollbar-width: none !important;
  /* IE 10+ */
  -ms-overflow-style: none !important;
}

/* Chrome, Safari, Opera */
.master::-webkit-scrollbar {
  display: none !important;
}


@media (max-width: 992px){
  .master {
      padding-top: 0px !important;
  }
}
</style>